import { Component, inject, OnInit } from '@angular/core';
import { CommonModule, NgOptimizedImage } from '@angular/common';
import { BannerAppComponent } from '../../banner-app/banner-app.component';
import { FooterAppComponent } from '../../footer-app/footer-app.component';
import { TrackingService } from '../../../services/tracking.service';
import { Store } from '@ngrx/store';
import { selectData } from '../../../storage/Lead/data.selectors';
import { selectPlanes } from '../../../storage/Planes/planes.selector';
import { selectCotizacion } from '../../../storage/Cotizacion/cotizacion.selectors';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-feedback-simple',
  standalone: true,
  imports: [
    BannerAppComponent,
    CommonModule,
    FooterAppComponent,
    NgOptimizedImage
  ],
  templateUrl: './feedback-simple.component.html',
  styleUrls: ['./feedback-simple.component.scss']
})
export class FeedbackSimpleComponent implements OnInit {

  // Inyección de dependencias moderna y consistente
  private readonly store = inject(Store);
  private readonly trackingService = inject(TrackingService);
  
    private readonly datosGenerales$ = this.store.select(selectData);
    private readonly datosPlanes$ = this.store.select(selectPlanes);
    private readonly datosCotizacion$ = this.store.select(selectCotizacion);
  
    // Convierte los Observables en Signals de solo lectura.
    // toSignal maneja la suscripción y desuscripción automáticamente.
    readonly datosGenerales = toSignal(this.datosGenerales$);
    readonly datosPlanes = toSignal(this.datosPlanes$);
    readonly datosCotizacion = toSignal(this.datosCotizacion$);

  ngOnInit(): void {
    
    this.trackingService.enviarEventoYaTenemosTusDatos('ya_tenemos_tus_datos', 'Pageview');
  }

  /**
   * Navega a la página de inicio de Sura.
   */
  volverAlInicio(): void {
    this.trackingService.enviarEventoYaTenemosTusDatos('ya_tenemos_tus_datos', 'Button', 'Volver al inicio');
    window.location.href = "https://www.sura.co/";
  }
}